module.exports = __webpack_public_path__ + "media/shapan.d7ee3f32.wav";